import React, { useState } from 'react';
import { Bot } from '../types/api';
import { botAPI } from '../services/api';
import BotFormModal, { BotFormData, defaultFormData, formDataToPayload } from './BotFormModal';

interface CreateBotModalProps {
  onClose: () => void;
  onBotCreated: (bot: Bot) => void;
}

const CreateBotModal: React.FC<CreateBotModalProps> = ({ onClose, onBotCreated }) => {
  const [formData, setFormData] = useState<BotFormData>(defaultFormData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validate mandatory fields
    if (formData.testnet) {
      if (!formData.binance_testnet_api_key || !formData.binance_testnet_secret_key) {
        setError('Binance Testnet API Key and Secret are required');
        setLoading(false);
        return;
      }
    } else {
      if (!formData.binance_api_key || !formData.binance_secret_key) {
        setError('Binance API Key and Secret are required');
        setLoading(false);
        return;
      }
    }

    if (!formData.gemini_api_key) {
      setError('Gemini API Key is required');
      setLoading(false);
      return;
    }

    if (formData.news_fetcher && !formData.cryptopanic_api_key) {
      setError('CryptoPanic API Key is required when News Fetching is enabled');
      setLoading(false);
      return;
    }

    if (formData.telegram_notifications && (!formData.telegram_bot_token || !formData.telegram_chat_id)) {
      setError('Telegram Bot Token and Chat ID are required when Telegram Notifications are enabled');
      setLoading(false);
      return;
    }

    try {
      const payload = formDataToPayload(formData);
      const newBot = await botAPI.createBot(payload);
      onBotCreated(newBot);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to create bot');
    } finally {
      setLoading(false);
    }
  };

  return (
    <BotFormModal
      title="Create New Trading Bot"
      submitText="Create Bot"
      loadingText="Creating..."
      formData={formData}
      setFormData={setFormData}
      onSubmit={handleSubmit}
      onClose={onClose}
      loading={loading}
      error={error}
      isEdit={false}
    />
  );
};

export default CreateBotModal;